import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const helpData = {
  UpgradeWallet: [
    {
      question: "How do I upgrade my wallet?",
      answer: `Please refer to the below steps:

Upgrade to Full KYC a/c:
- Method1 (Manual process) : Please visit in person to Transaction Analysts India Pvt Ltd, Bangalore Office. for details go to contact us "In home page".
- Method2 (Video Kyc) : Users can book the slot to upgrade wallet to full Kyc from Mobile/Web Application .`,
    },
  ],
};

const UpgradeWallet = ({ selectedSection = "UpgradeWallet" }) => {
  const questions = helpData[selectedSection] || [];
  const [openIndex, setOpenIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const toggleAnswer = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <Box flex={1}>
      {/* Top Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 180, sm: 260 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
        }}
      >
        <Box
          component="img"
          src="/Assets/Upgradewallet.jpg"
          alt="Upgrade Wallet Banner"
          sx={{
            width: "100%",
            maxWidth: 950,
            height: "100%",
            objectFit: "cover",
            borderRadius: "0 0 12px 12px",
          }}
        />
      </Box>

      {/* Heading */}
      <Box mt={4} textAlign="center" px={2}>
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          color="black"
        >
          Upgrade Wallet
        </Typography>
      </Box>

      {/* FAQ Section */}
      <Box maxWidth="900px" mx="auto" px={2} py={4}>
        <List disablePadding>
          {questions.map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                mb: 2,
                overflow: "hidden",
                boxShadow:
                  openIndex === index ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
              }}
            >
              <ListItemButton
                onClick={() => toggleAnswer(index)}
                sx={{
                  px: 2,
                  py: 1.5,
                  borderBottom: "1px solid #eee",
                  backgroundColor:
                    openIndex === index ? "#e0f7fa" : "transparent",
                  "&:hover": {
                    backgroundColor:
                      openIndex === index ? "#b2ebf2" : "#f9f9f9",
                  },
                }}
              >
                <ListItemText
                  primary={
                    <Typography fontWeight="medium">{item.question}</Typography>
                  }
                />
                {openIndex === index ? (
                  <ExpandMoreIcon sx={{ fontSize: 18 }} />
                ) : (
                  <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                )}
              </ListItemButton>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Box px={3} py={2} bgcolor="#fafafa">
                  <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                    {item.answer}
                  </Typography>
                </Box>
              </Collapse>
            </Box>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default UpgradeWallet;
